import { MutationTree } from 'vuex';
import { MainStateInterface } from './state';

const mutation: MutationTree<MainStateInterface> = {
  setPage(state: MainStateInterface, val) {
    state.page = val;
  },
  setSymbols(state: MainStateInterface, val) {
    state.symbols = val;
  },
  setCountries(state: MainStateInterface, val) {
    state.countries = val;
  },
  setCurrencies(state: MainStateInterface, val) {
    state.currencies = val;
  },
  setBitflowCurrencies(state: MainStateInterface, val) {
    state.bitflowCurrencies = val;
  },
  setUser(state: MainStateInterface, val) {
    state.user = val;
  },
  setAccessToken(state: MainStateInterface, val) {
    state.accessToken = val;
  },
  setRefreshToken(state: MainStateInterface, val) {
    state.refreshToken = val;
  },
  setPermissions(state: MainStateInterface, val) {
    state.permissions = val;
  },
  setUpdates(state: MainStateInterface, val) {
    state.updates = val;
  },
}

export default mutation;
